var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1MedicalSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 23H49v-5a4 4 0 00-4-4H31a4 4 0 00-4 4v5H15.52A4 4 0 0012 27v27a4 4 0 004 4h44a4 4 0 004-4V27a4 4 0 00-4-4zm-29-5h14v5H31v-5zm7 35a12 12 0 110-24 12 12 0 010 24zm2-14h6v4h-6v6h-4v-6h-6v-4h6v-6h4v6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Medical_suitcase.04f7bcff.svg";
export { SvgK1MedicalSuitcase as ReactComponent };